/**
 * IDs of prepared drafts included in multi-country bulk edit (selection + static-tag propagation).
 */

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

function selectedStaticTagNames(selectedIds: string[], drops: PreparedDrop[]): Set<string> {
  const selected = new Set(selectedIds);
  const tags = new Set<string>();
  for (const d of drops) {
    if (selected.has(d.id) && d.staticTag?.name) tags.add(d.staticTag.name);
  }
  return tags;
}

/** Drafts in propagated countries that share a static tag name with the current selection. */
export function getPropagationDraftIds(
  propagateToCountries: string[],
  selectedIds: string[],
  drops: PreparedDrop[],
): string[] {
  if (propagateToCountries.length === 0) return [];
  const tagNames = selectedStaticTagNames(selectedIds, drops);
  if (tagNames.size === 0) return [];
  const ckSet = new Set(propagateToCountries);
  return drops
    .filter(
      (d) =>
        d.status === 'DRAFT' &&
        ckSet.has(d.countryKey) &&
        d.staticTag?.name != null &&
        tagNames.has(d.staticTag.name),
    )
    .map((d) => d.id);
}

export function mergeBulkEditDraftIds(
  selectedIds: string[],
  propagateToCountries: string[],
  drops: PreparedDrop[],
): string[] {
  const propagated = getPropagationDraftIds(propagateToCountries, selectedIds, drops);
  return [...new Set([...selectedIds, ...propagated])];
}

export function countAffectedBulkEditDrafts(
  selectedIds: string[],
  propagateToCountries: string[],
  drops: PreparedDrop[],
): number {
  return mergeBulkEditDraftIds(selectedIds, propagateToCountries, drops).length;
}
